"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.STREETVIEW_EVENTS = exports.MAP_EVENTS = void 0;
// taken from: https://developers.google.com/maps/documentation/javascript/reference#map
const MAP_EVENTS = exports.MAP_EVENTS = ['bounds_changed', 'center_changed', 'click', 'contextmenu', 'dblclick', 'drag', 'dragend', 'dragstart', 'heading_changed', 'idle', 'maptypeid_changed', 'mousemove', 'mouseout', 'mouseover', 'projection_changed', 'resize', 'rightclick', 'tilesloaded', 'tilt_changed', 'zoom_changed'];
const STREETVIEW_EVENTS = exports.STREETVIEW_EVENTS = ['streetview_entered', 'streetview_exited'];